import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledMobileCalendarContainer = styled.div`
  .mobile-calendar-container-modal {
    .dropdown-to-modal {
      height: 80vh;
      padding: ${toRem(24)} ${toRem(16)} 0 ${toRem(16)};
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      .m-dropdown-content {
        display: flex !important;
        flex-direction: column;
        height: 100%;
        min-height: unset;
        max-height: 100%;
        z-index: 99;
      }
    }

    .m-dropdown-header {
      flex-shrink: 0;
    }

    .m-dropdown-children {
      flex: 1;
      overflow: hidden;
      min-height: 0;
      display: flex;
      flex-direction: column;
      height: 0;
    }

    .modal-content-wrapper {
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: hidden;
    }

    .modal-body {
      flex: 1;
      overflow-y: auto;
      min-height: 0;
      padding-bottom: ${toRem(16)};
    }

    .modal-common-footer {
      flex-shrink: 0;
      padding: ${toRem(16)} 0;
      display: flex;
      justify-content: flex-end;
      .apply-btn {
        width: 100%;
        height: ${toRem(48)};
      }
    }
  }
`;
